<template>
  <div class="resourceApp__selectedFilters">
    <ul class="selectedFilters__list" v-cloak>
      <li v-for="tag in displayedTags" class="selectedFilters__item">
        <button
          class="selectedFilters__button"
          :title="'Search by ' + tag.text"
          v-on:click="tagClicked(tag)"
        >
          {{ tag.text }}
        </button>
      </li>
      <li
        v-if="tags.length > displayedTags.length"
        class="selectedFilters__item"
      >
        <button class="selectedFilters__button" v-on:click="reveal = true">
          + {{ tags.length - displayedTags.length }} more
        </button>
      </li>
      <li
        v-if="displayedTags.length > cap && reveal"
        class="selectedFilters__item"
      >
        <button class="selectedFilters__button" v-on:click="reveal = false">
          - less
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "curtainTags",
  props: {
    tags: {
      type: Array,
      default: [],
    },
    cap: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      reveal: false,
    };
  },
  computed: {
    displayedTags() {
      if (this.tags.length <= this.cap + 1 || this.reveal) return this.tags;
      else {
        return this.tags.slice(0, this.cap);
      }
    },
  },
  methods: {
    tagClicked(tag) {
      this.$emit("tag-clicked", tag);
    },
  },
};
</script>

<style scoped lang="scss"></style>
